"use server";

import { cookies } from "next/headers";
import { redirect } from "next/navigation";
import { createClient } from "@/utils/supabase/server";

/**
 * Customer sign-out. signOut() clears the auth cookies through the server
 * client's cookie adapter, so the session is invalidated server-side. redirect()
 * throws, so it stays outside any try/catch. "/" sends the visitor back to their
 * remembered city.
 */
export async function signOut(): Promise<void> {
  const supabase = createClient(await cookies());
  await supabase.auth.signOut();
  redirect("/");
}
